<template>
  <div class="header">
    <div class="header__left">
      <slot name="left" />
    </div>
    <h1 class="header__title">
      <slot name="title" />
    </h1>
    <div class="header__right">
      <slot name="right" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.header {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  width: 100%;
  max-width: 500px;
  height: 56px;
  background-color: $base-white;
  z-index: 100;
}

.header__title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
}
</style>
